/**
 * @generated SignedSource<<ef98f8cde7d0ed6357540fb8d4a6812d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "crmId"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "crmId",
        "variableName": "crmId"
      }
    ],
    "concreteType": "Employee",
    "kind": "LinkedField",
    "name": "deleteEmployee",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "crmId",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "EmployeesPermissionsTableDeleteMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "EmployeesPermissionsTableDeleteMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "d985b3cd3ce11bd8ade395fad675fc4e",
    "id": null,
    "metadata": {},
    "name": "EmployeesPermissionsTableDeleteMutation",
    "operationKind": "mutation",
    "text": "mutation EmployeesPermissionsTableDeleteMutation(\n  $crmId: String!\n) {\n  deleteEmployee(crmId: $crmId) {\n    crmId\n  }\n}\n"
  }
};
})();

node.hash = "d98ee06b4468b452f86c66571bf96d9a";

module.exports = node;
